<template>
  <div>
    <center>
      <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-img height="100%" class="align-end" :src="imageQuest">
      </v-img>
    <v-col cols="6">
      <v-btn block
      dark
      x-large
      color="#C62929"
      @click="close()"
      >
    เรียบร้อย
  </v-btn>
    </v-col>
    </center>
  </div>
</template>
<script>
// import axios from 'axios'
export default {
  components: {
  },
  name: 'Info',
  data () {
    return {
      center: {},
      profile: [],
      form: {
        userLineuserId: ''
      },
      dataReady: true,
      imageQuest: ''
    }
  },
  async mounted () {
    // Get Line Profile
    this.imageQuest = require('@/assets/iconMenu/banerRat.jpg')
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
  },
  methods: {
    close () {
      this.$router.push('/Liff/WelfareHistory')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
.textHead {
  font-family: "Kanit";
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/QuestSuccess.vue